import React from 'react'

function Footer() {
    return (
        <div className="Footer">
            <p> Github <a href="https://github.com/saravananselvaraju/react-bartender">react-bartender</a></p>
        </div>
    )
}

export default Footer;